import React from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { IconButton } from "@material-ui/core";
import QuestionAnswerRoundedIcon from "@mui/icons-material/QuestionAnswerRounded";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import { extraLoadChat } from "actions/chat/chat";
import CreateJobModal from "./CreateJobModal";
import AddMemberModal from "./AddMemberModal";
import {
  CREATE_TASK,
  CustomEventDispose,
  CustomEventListener,
} from "constants/events";
import "./styles.scss";

const findProjectInListBasic = (projectsBasic = [], projectId = undefined) => {
  let projects = [];
  projectsBasic.map((e) => {
    projects = [...projects, ...e.projects];
  });
  const project = projects.find((e) => e.id === projectId);
  return project ? project : {};
};

function ListHeader({ isShowFilter, handleShowFilter, tagSelected }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const projectsData = useSelector(
    (state) => state.taskDetail.commonTaskDetail
  );
  const projectThis = findProjectInListBasic(
    projectsData.projectListBasic
      ? projectsData.projectListBasic.projectGroups
      : [],
    projectsData.activeProjectId
  );
  const task = useSelector((state) => state.taskDetail.detailTask.taskDetails);

  const [openCreateJobModal, setOpenCreateJobModal] = React.useState(false);
  const [showAddMember, setShowAddMember] = React.useState(false);

  React.useEffect(() => {
    if (projectThis.id) {
      CustomEventListener(CREATE_TASK, (e) => {
        if (
          !localStorage.getItem(
            `MODAL_MEMBER_TASK_MARK_NOT_SHOW_${projectThis.id}`
          )
        ) {
          setShowAddMember(e?.detail?.task);
        }
      });
      return () => {
        CustomEventDispose(CREATE_TASK, (e) => {
          if (
            !localStorage.getItem(
              `MODAL_MEMBER_TASK_MARK_NOT_SHOW_${projectThis.id}`
            )
          ) {
            setShowAddMember(e.detail.task);
          }
        });
      };
    }
  }, [projectThis]);

  const handleClickFilter = () => {
    if (isShowFilter && tagSelected) {
      dispatch(extraLoadChat(task?.id));
    }
    handleShowFilter();
  };

  return (
    <>
      <div className="listHeader">
        <div className="listHeader--content">
          <span className="left-block">
            <IconButton color="primary">
              <QuestionAnswerRoundedIcon />
            </IconButton>
            <span className="title">
              {t("LABEL_CHAT_TASK_GENERAL_DISCUSSION")}
            </span>
          </span>
          <IconButton
            onClick={handleClickFilter}
            className={classNames("filter-btn", {
              "filter-btn--active": isShowFilter,
            })}
          >
            <FilterAltRoundedIcon />
          </IconButton>
        </div>
      </div>
      <CreateJobModal
        isOpen={openCreateJobModal}
        setOpen={setOpenCreateJobModal}
      />
      {showAddMember && (
        <AddMemberModal
          isOpen={showAddMember}
          setOpen={setShowAddMember}
          task={showAddMember}
          projectId={projectThis.id}
        />
      )}
    </>
  );
}

export default ListHeader;
